import React from 'react'
import { Link } from 'react-router-dom'
import { MdKeyboardArrowRight } from 'react-icons/md';

function AboutUsBanner() {
    return (
        <>
            <div className="aon-page-benner-area">
                <div
                    className="aon-page-banner-row AboutUs-bg"
                >
                    <div
                        className="sf-overlay-main"
                        style={{ opacity: "0.8", backgroundColor: "#022279" }}
                    />
                    <div className="sf-banner-heading-wrap">
                        <div className="sf-banner-heading-area">
                            <div className="sf-banner-heading-large">About Us</div>
                            <div className="sf-banner-breadcrumbs-nav">
                                <ul className="list-inline">
                                    <Link to="/" className='text-decoration-none text-white'>Home
                                        <MdKeyboardArrowRight className='mx-1' />
                                    </Link>
                                    <Link to="/" className='text-decoration-none text-white '>About US</Link>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutUsBanner
